<script>
	export let postfix = "";
	export let steps = 2;
	export let stage = 1;

	let indicators;

	$: indicators = Array(steps)
		.fill(stage)
		.map((_, idx) => {
			const div = document.createElement("div");
			div.classList.add("bubble");

			if (idx + 1 === stage) {
				div.classList.add("bubble--active");
			} else if (idx + 1 < stage) {
				div.classList.add("bubble--seen");
			}

			return div;
		});
</script>

<div class="progress-indicators {postfix}">
	{#each indicators as indicator}
		{#key stage}
			{@html indicator.outerHTML}
		{/key}
	{/each}
</div>

<style>
	.progress-indicators {
		width: 70%;
		padding: 1em;
		margin: 0.5em auto;
	}
</style>
